import { Language } from "@mui/icons-material";
import {
  Button,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import { getLocalizedMessage, SupportedLanguage } from "@pimo/pimo-l10n";
import { useState } from "react";

const languageOptions: {
  code: SupportedLanguage;
  label: string;
}[] = [
  { code: "de", label: "german" },
  { code: "en", label: "english" },
];

interface ChangeLanguageButtonProps {
  language: SupportedLanguage;
  onLanguageChange: (newLanguage: SupportedLanguage) => void;
  isMenuCmponent?: boolean;
}

export const ChangeLanguageButton = ({
  language,
  onLanguageChange,
  isMenuCmponent,
}: ChangeLanguageButtonProps) => {
  const [anchorEl, setLanguageMenuAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorEl);
  const handleLanguageMenuButtonClick = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setLanguageMenuAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuItemClick = (newLanguage: SupportedLanguage) => {
    setLanguageMenuAnchorEl(null);
    newLanguage && onLanguageChange(newLanguage);
  };

  const handleLanguageMenuClose = () => {
    setLanguageMenuAnchorEl(null);
  };
  return (
    <>
      {isMenuCmponent ? (
        <ListItemButton onClick={handleLanguageMenuButtonClick}>
          <ListItemIcon>
            <Language />
          </ListItemIcon>
          <ListItemText>
            {getLocalizedMessage(language, "userMenu.language")}
          </ListItemText>
        </ListItemButton>
      ) : (
        <Button onClick={handleLanguageMenuButtonClick} variant="outlined">
          <Language sx={{ paddingRight: 1 }} />
          {getLocalizedMessage(language, "userMenu.language")}
        </Button>
      )}
      <Menu open={open} onClose={handleLanguageMenuClose} anchorEl={anchorEl}>
        {languageOptions.map((option) => (
          <MenuItem
            key={option.code}
            onClick={() => handleLanguageMenuItemClick(option.code)}
            selected={option.code === language}
          >
            <ListItemText
              primary={getLocalizedMessage(
                language,
                `userMenu.${option.label}`
              )}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
